import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13024824"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "personal-head" }
const _hoisted_2 = { class: "head-portrait" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "setting" }
const _hoisted_5 = { class: "personal-attribute" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "jump-login"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Log In", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sign-up" }, "Sign Up", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_11 = { class: "my-orders" }
const _hoisted_12 = { class: "my-assets" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "my-tools" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Headline = _resolveComponent("Headline")!
  const _component_IconDesign = _resolveComponent("IconDesign")!
  const _component_tabbar = _resolveComponent("tabbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["personal-center", {'hide_div' : $setup.is_act_wallet_view} ])
  }, [
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: $setup.loginSate ? '/my-profile' : '/login'
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: 
                $setup.userData.avatar_url
                  ? _ctx.webpFilters($setup.userData.avatar_url)
                  : 'https://image.kilimall.com/global/images/avatar.png.webp'.webpFilters()
              ,
                  alt: ""
                }, null, 8, _hoisted_3),
                _createElementVNode("span", null, _toDisplayString($setup.userData.name ? $setup.userData.name : $setup.userData.username), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: "/setting" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_icon, {
                  name: "setting-o",
                  size: "18",
                  color: "#fff"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.attribute, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.title,
                onClick: ($event: any) => ($setup.jump_func(item.url))
              }, [
                _createElementVNode("p", null, _toDisplayString(item.amount ? (item.amount > 99 ? 99 + "+" : item.amount) : "0"), 1),
                _createElementVNode("h5", null, _toDisplayString(item.title), 1)
              ], 8, _hoisted_6))
            }), 128))
          ]),
          (!$setup.loginSate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_router_link, { to: "/login" }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/login?type=register" }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _hoisted_10,
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Headline, {
            title: "My Orders",
            more: true,
            moreSize: "View All",
            size: "14",
            colors: "#333",
            skipPath: "/order"
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_IconDesign, {
              colorSize: "#000",
              linefew: $setup.IconMyOrdersLinefew,
              iconList: $setup.IconMyOrders
            }, null, 8, ["linefew", "iconList"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode(_component_Headline, {
          title: "My Assets",
          size: "14",
          colors: "#333"
        }),
        _createElementVNode("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myAssets, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.title,
              onClick: ($event: any) => ($setup.jump_func(item.url))
            }, [
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(index === 0 ? $setup.currencyUnit : "") + " ", 1),
                _createElementVNode("span", null, _toDisplayString(index === 0
                ? $setup.moneyValue
                  ? parseInt(item.amount).thousands()
                  : "***"
                : item.amount), 1)
              ]),
              _createElementVNode("div", {
                onClick: _withModifiers(($event: any) => (index === 0 ? $setup.control_btns() : null), ["stop"])
              }, [
                _createTextVNode(_toDisplayString(item.title) + " ", 1),
                (index === 0 && $setup.moneyValue)
                  ? (_openBlock(), _createBlock(_component_van_icon, {
                      key: 0,
                      name: "closed-eye"
                    }))
                  : _createCommentVNode("", true),
                (index === 0 && !$setup.moneyValue)
                  ? (_openBlock(), _createBlock(_component_van_icon, {
                      key: 1,
                      name: "eye"
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_14)
            ], 8, _hoisted_13))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode(_component_Headline, {
          title: "My Tools",
          size: "14",
          colors: "#333"
        }),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_IconDesign, {
            newline: "",
            linefew: 4,
            colorSize: "#000",
            iconList: $setup.IconMyTools
          }, null, 8, ["iconList"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_tabbar, { active: $setup.tabbar_index }, null, 8, ["active"])
  ], 2))
}